import React from "react";

const LicenseeTerms = () => {
  return (
    <div className="min-h-screen bg-[#0e0e0f] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-[#1B1B1C] rounded-lg shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-black text-yellow-400 px-6 py-8">
          <h1 className="text-3xl font-bold text-center mb-2">
            VUPOP LICENSEE TERMS
          </h1>
          {/* <p className="text-yellow-300 text-center text-lg">(APP USERS)</p> */}
        </div>

        <div className="px-6 py-8">
          {/* Introduction */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <div className="w-2 h-8 bg-yellow-400 mr-3"></div>
              <h2 className="text-2xl font-bold text-white">
                Hi, we're <span className="text-yellow-400">VuPop</span>!
              </h2>
            </div>
            <p className="text-gray-300 mb-4">
              Our official name is Social On Air Limited, a company registered
              under the laws of England and Wales (registered number 15140619)
              with our registered office at 11a Abbey Road, Malvern, England,
              WR14 3ES ("<strong>VuPop</strong>", "<strong>we</strong>", "
              <strong>us</strong>" and "<strong>our</strong>"). These terms of
              use ("<strong>Terms</strong>") apply to the use of the Services
              (as defined below). Each individual or organisation wishing to
              make use of the Services ("<strong>you</strong>", the "
              <strong>User</strong>" or "<strong>your</strong>") is subject to
              these Terms, together with any other documents or terms that apply
              to the Services offered and used (together, the "
              <strong>Agreement</strong>").
            </p>

            <div className="bg-[#434345] p-6 rounded-lg border-l-4 border-black mt-6">
              <p className="font-semibold text-gray-300 mb-3">
                By clicking or tapping any button or box marked "accept",
                "agree" or "ok" (or a similar term) referencing these Terms, or
                by signing up to the Services via a website, app or other
                digital channel, you confirm that:
              </p>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-start">
                  <span className="text-black font-bold mr-2">•</span>
                  <span>you are bound by these Terms;</span>
                </li>
                <li className="flex items-start">
                  <span className="text-black font-bold mr-2">•</span>
                  <span>
                    you are of legal age where you live (18 or over if you live
                    in the UK); and
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-black font-bold mr-2">•</span>
                  <span>
                    you have the legal capacity to enter into this Agreement,
                    either as an individual or as an authorised representative
                    of your company.
                  </span>
                </li>
              </ul>
            </div>

            <div className="mt-6 p-4 bg-yellow-100 rounded-lg">
              <p className="text-gray-700">
                <strong>
                  You should print and keep a copy of these Terms for future
                  reference.
                </strong>
              </p>
              <p className="text-gray-700 mt-2">
                <strong>
                  Your attention is drawn in particular to the warranties,
                  indemnities and limitations of liability in Clauses 10 and 11.
                </strong>
              </p>
            </div>
          </div>

          {/* AGREED TERMS Section */}
          <div className="mb-8">
            <div className="bg-black text-yellow-400 px-4 py-3 rounded-t-lg">
              <h2 className="text-xl font-bold uppercase tracking-wide">
                AGREED TERMS
              </h2>
            </div>

            {/* Clause 1 */}
            <div className="border border-gray-700 rounded-b-lg p-6">
              <h3 className="text-xl font-bold text-white mb-4">
                1. DEFINITIONS AND INTERPRETATION
              </h3>

              <div className="mb-6 text-gray-300">
                <h4 className="font-semibold text-gray-300 mb-3">
                 <strong>1.1 </strong> The definitions and rules of interpretation in this Clause
                  apply to these Terms.
                </h4>

                <div className="ml-4 space-y-4">
                  <div>
                    <p>
                      <strong>"Active Editors"</strong> means, from time to
                      time, any active Editor appointments made by your Licensee
                      Manager. Active Editors include any appointments within
                      your Allocated Editor Seats together with any Additional
                      Editors.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Additional Editor"</strong> means, in any 24-hour
                      period (calculated from midnight UK time), any Active
                      Editors in excess of your Allocated Editor Seats.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Additional Editor Fees"</strong> means the
                      additional fees based on the number of Additional Editors
                      your Licensee Manager has appointed, as notified to you
                      prior to sign-up or otherwise as varied or agreed in
                      accordance with these Terms.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Allocated Editor Seats"</strong> means the
                      maximum number of concurrent Active Editors included in
                      your Platform Fees, as notified to you prior to sign-up or
                      otherwise as varied or agreed in accordance with these
                      Terms.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"App"</strong> means the VuPop mobile app which
                      allows Licensors to upload Clips.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"App Services"</strong> means any software,
                      content or services made available via the App, now or in
                      the future.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"App Terms"</strong> means the terms and
                      conditions between the Licensor and VuPop in relation to
                      the VuPop App.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Broker’s Fee"</strong> has the meaning given in
                      Clause 4.1(b).
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Business Day"</strong> means a day other than a
                      Saturday, Sunday or public holiday in England when banks
                      in London are open for business.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Chosen Settings"</strong> has the meaning given
                      at Clause 3.2(b).
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Clip"</strong> means all or part of a digital
                      video or image file, with or without accompanying audio
                      content, that is available to license from a Licensor via
                      the Services.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Clip Terms"</strong> means an agreement between
                      you and any Licensor setting out the terms on which you
                      license a Clip. The version of the Clip Terms in force at
                      the Effective Date can be found at Schedule 1 to these
                      Terms.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Confidential Information"</strong> means the
                      Licensee Confidential Information and/or the VuPop
                      Confidential Information as appropriate.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Control"</strong> shall be as defined in section
                      1124 of the Corporation Tax Act 2010, and the expression
                      "change of Control" shall be construed accordingly.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Data Protection Laws"</strong> mean all
                      applicable laws in relation to data protection, privacy,
                      interception and monitoring of communications, or
                      requirements relating to the processing of personal data
                      of any kind.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Derived Data"</strong> means any documentation,
                      information, reports, data, analysis, files or materials
                      created: (a) by the Services; or (b) from or incorporating
                      any User Data.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Dispute"</strong> has the meaning given in Clause
                      14.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Documentation"</strong> means all service
                      descriptions, user manuals, instructions, materials and/or
                      other documents or information provided or otherwise made
                      available to the Licensee by VuPop in relation to the
                      Services.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Editor"</strong> means an approved user of the
                      Services who has the authority to license Clips on your
                      behalf.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Effective Date"</strong> means the date on which
                      you first accept these Terms or sign up to or use the
                      Services via a website, app or other digital channel,
                      whichever is the earliest.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Fees"</strong> means, together, the Platform
                      Fees, any Additional Editor Fees, and any applicable
                      Licence Fees.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Force Majeure Event"</strong> has the meaning
                      given in Clause 13.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>“Initial Term” </strong> has the meaning given at
                      Clause 12.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Intellectual Property” </strong> means patents,
                      utility models, rights to inventions, copyright and
                      related rights, trade marks and service marks, rights in
                      and to trade names and domain names, rights in get-up,
                      goodwill and the right to sue for passing off or unfair
                      competition, rights in designs, rights in computer
                      products, database rights, rights to preserve the
                      confidentiality of information (including know-how and
                      trade secrets) and any other intellectual property rights,
                      including all applications for (and rights to apply for
                      and be granted), renewals or extensions of, and rights to
                      claim priority from, such rights and all similar or
                      equivalent rights or forms of protection which subsist or
                      will subsist, now or in the future, in any part of the
                      world.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Licence Fees” </strong> mean the fees paid by
                      you to license a Clip under the Clip Terms, calculated in
                      accordance with the Licence Rates.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Licence Rates” </strong> means the rates
                      notified to you prior to sign-up or otherwise as varied or
                      agreed in accordance with these Terms from time to time.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Licensee Confidential Information” </strong> has
                      the meaning given in Clause 9.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Licensee Default” </strong> has the meaning
                      given at Clause 6.2.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Licensee Manager” </strong> means the
                      individual(s) with overall responsibility for your
                      organisation’s Editors.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Licensor” </strong> means the Party that has
                      provided the Clip.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Membership Tier</strong> the ‘tier’ you have
                      selected in respect of the Services, as described in the
                      Documentation.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>“Normal Working Hours” </strong> mean 9.00 am to
                      5.00 pm UK time, each Business Day.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>“Party” </strong> means VuPop or the Licensee (and
                      “Parties” shall be construed accordingly).
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>“Personnel” </strong> means a Party’s directors,
                      officers, partners, principals, employees, agents,
                      auditors, consultants, representatives, advisers and
                      subcontractors.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Platform Fees” </strong> means the fees payable
                      for your use of the Services, as agreed between the
                      Parties prior to or during sign-up.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Renewal Term” </strong> has the meaning given at
                      Clause 12.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>“Services” </strong> means any software, content
                      and materials (other than the Clips) and services made
                      available at the Website, now or in the future, and the
                      Documentation.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>“Term” </strong> has the meaning given at Clause
                      12.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “User Data” </strong> means, together: (a) any
                      data inputted to the Services by or on behalf of the
                      Licensee; (b) any information about how your Editors
                      and/or Licensee Managers interact with the Services; and
                      (c) any metadata relating to either of the foregoing.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “VAT” </strong> means Value Added Tax, as defined
                      by the Value Added Tax Act 1994.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Vault"</strong> means the library of Clips which
                      are available for you to license from Licensors under the
                      Clip Terms.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Virus” </strong> means any thing or device
                      (including any software, code, file or programme) which
                      may: prevent, impair or otherwise adversely affect the
                      operation of any computer software, hardware or network,
                      any telecommunications service, equipment or network or
                      any other service or device; prevent, impair or otherwise
                      adversely affect access to or the operation of any
                      programme or data, including the reliability of any
                      programme or data (whether by re-arranging, altering or
                      erasing the programme or data in whole or part or
                      otherwise); or adversely affect the user experience,
                      including worms, trojan horses, viruses and other similar
                      things or devices.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “Vulnerability” </strong> means a weakness in the
                      computational logic (for example, code) found in software
                      and hardware components that when exploited, results in a
                      negative impact to the confidentiality, integrity, or
                      availability, and the term “Vulnerabilities” shall be
                      interpreted accordingly.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong> “VuPop Confidential Information” </strong> has
                      the meaning given in Clause 9.3.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Website"</strong> means our website at{" "}
                      <a
                        href="https://www.vupop.io"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-yellow-400 hover:text-yellow-300"
                      >
                        www.vupop.io
                      </a>{" "}
                      (or any successor URL).
                    </p>
                  </div>
                </div>
              </div>

              <div className="ml-4 space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>1.2</strong> Clause, schedule and paragraph headings
                    are for convenience only and do not affect the
                    interpretation of this Agreement.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.3</strong> References to Clauses and Schedules are
                    to the clauses and schedules of these Terms.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.4</strong> A person includes an individual,
                    corporate or unincorporated body (whether or not having
                    separate legal personality) and that person's legal and
                    personal representatives, successors or permitted assigns.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.5</strong> A reference to a company shall include
                    any company, corporation or other body corporate, wherever
                    and however incorporated or established.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.6</strong> Unless the context otherwise requires,
                    words in the singular shall include the plural and in the
                    plural shall include the singular, and a reference to one
                    gender (or none) shall include a reference to the other
                    genders (or none).
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.7</strong> A reference to a statute or statutory
                    provision is a reference to such legislation as amended,
                    modified or re-enacted from time to time and shall include
                    all subordinate legislation made under that statute or
                    statutory provision (as amended, modified or re-enacted from
                    time to time).
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.8</strong> Any words following the terms{" "}
                    <strong>including</strong>, <strong>include</strong>,{" "}
                    <strong>in particular</strong>, <strong>for example</strong>{" "}
                    or any similar expression shall be construed as illustrative
                    and shall not limit the sense of the words, description,
                    definition, phrase or term preceding those terms. Any
                    reference to writing includes email.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.9</strong> Any obligation on a Party not to do
                    something includes an obligation not to allow that thing to
                    be done.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.10</strong> A reference to 'writing' or 'written'
                    includes email but not fax.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                2. LICENCE AND USERS
              </h3>

              <div className="text-gray-300 space-y-6">
                <div>
                  <p>
                    <strong>2.1</strong> Subject to your payment of the Fees and
                    the other terms and conditions of this Agreement, VuPop
                    hereby grants to you a non-exclusive, non-transferable right
                    and licence, without the right to grant sublicences, to
                    permit your Active Editors to use the Services during the
                    Term solely for your internal business operations.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>2.2</strong> You undertake that:
                  </p>
                  <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
                    <li>
                      you will not allow any Editor’s account or log-in details
                      to be used by more than one individual;
                    </li>
                    <li>
                      each Editor shall keep a secure password for their use of
                      the Services, and such password shall be changed no less
                      frequently than every six months and each Editor shall
                      keep their password confidential;
                    </li>
                    <li>
                      you shall maintain a written, up to date list of current
                      Editors and provide such list to VuPop within five
                      Business Days of VuPop’s written request at any time or
                      times;
                    </li>
                    <li>
                      you shall permit VuPop or VuPop’s auditor to audit the
                      Services in order to establish the name and password (if
                      applicable) of each Editor and your compliance with this
                      Agreement. Each such audit may be conducted no more than
                      once per quarter, at VuPop’s expense, and this right shall
                      be exercised with reasonable prior notice and in such a
                      manner as not to substantially interfere with your normal
                      conduct of business; and
                    </li>
                    <li>
                      if any of the audits referred to in Clause 2.2(d) reveal
                      that more individuals and/or Editors have accessed the
                      Services than the number of Active Editors you have
                      requested or declared, then without prejudice to VuPop’s
                      other rights, VuPop may pro-rate the Additional Editor
                      Fees accordingly and invoice you for any shortfall.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>2.3</strong> You acknowledge and agree that:
                  </p>
                  <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
                    <li>
                      each Active Editor within your Allocated Editor Seats will
                      remain ‘active’ for a 72-hour period, after which their
                      appointment will automatically terminate; and
                    </li>
                    <li>
                      each Additional Editor you appoint will remain ‘active’
                      for a 24-hour period, after which their appointment will
                      automatically terminate.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>2.4</strong> These Terms apply only to our Website,
                    which allows you to pay a Licence Fee to license Clips from
                    Licensors. If you want to provide Clips and make them
                    available to third parties using VuPop’s services, you
                    should sign up to our App Terms as a Licensor{" "}
                    <a
                      href="https://www.vupop.io/legal/app-terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline text-yellow-400 hover:text-yellow-300"
                    >
                      [View App Terms]
                    </a>
                    . You can sign up as a Licensee under these Terms and as a
                    Licensor via the App, but the accounts will be separate.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                3. CLIPS AND CLIP TERMS
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>3.1</strong> If you want to download and/or use any
                    Clip for any purpose, you will need to pay a Licence Fee and
                    enter into the Clip Terms with the Licensor. A portion of
                    the Licence Fee is retained by VuPop, and the remainder goes
                    to the Licensor in question.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>3.2</strong> To license a Clip, you need to:
                  </p>
                  <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2 marker:text-gray-300 marker:font-semibold">
                    <li>select the Clip from our Vault;</li>
                    <li>
                      specify:
                      <ul className="list-[lower-roman] ml-6 mt-1 space-y-1 marker:text-gray-300 marker:font-semibold">
                        <li>
                          whether you wish to license the whole or a part of the
                          Clip; and
                        </li>
                        <li>
                          the settings you wish to apply to the download,
                          <span className="italic">
                            {" "}
                            (together, your “Chosen Settings”)
                          </span>
                          ;
                        </li>
                      </ul>
                    </li>
                    <li>
                      agree to pay the Licence Fee in accordance with Clauses
                      4.4 to 4.6, as applicable;
                    </li>
                    <li>enter into the Clip Terms with the Licensor.</li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>3.3</strong> We aim to make your chosen Clip
                    available to download immediately (and in any event no later
                    than the following Business Day) after you have completed
                    the steps set out at Clause 3.2.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>3.4</strong> You acknowledge, agree and understand
                    that:
                  </p>
                  <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2 marker:text-gray-300 marker:font-semibold">
                    <li>
                      VuPop’s Services enable you to license the Clips, but all
                      Clips are owned by the relevant Licensor (or their
                      licensors);
                    </li>
                    <li>
                      you are responsible for determining that your Chosen
                      Settings are appropriate for your intended use of any
                      Clip;
                    </li>
                    <li>
                      any Licence Fee you pay is specific to the relevant Clip,
                      formatted in accordance with your Chosen Settings. If you
                      wish to download a Clip with any different Chosen
                      Settings, an additional Licence Fee will apply;
                    </li>
                    <li>
                      the Clip Terms are a binding contract between you and the
                      Licensor. Please read them carefully and check that you
                      agree with all of their terms before you accept these
                      Terms;
                    </li>
                    <li>
                      the Clip Terms may be updated from time to time. We will
                      notify you of any updates, and you will be required to
                      accept the updates before licensing any further Clips.
                      However, this will not affect any agreement between you
                      and a Licensor that existed before those changes came into
                      effect;
                    </li>
                    <li>
                      VuPop helps to facilitate the transaction between you and
                      the Licensor, but VuPop is not a party to the Clip Terms.
                      If you have any dispute with a Licensor, you will need to
                      raise an ‘issue’ in respect of the relevant Clip via the
                      Vault.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">4. FEES</h3>

              <div className="space-y-8 text-gray-300">
                {/* Licence Fees */}
                <div>
                  <h4 className="font-semibold text-gray-100 mb-2">
                    Licence Fees
                  </h4>
                  <p>
                    <strong>4.1</strong> You acknowledge and agree that:
                  </p>
                  <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2 marker:text-gray-300 marker:font-semibold">
                    <li>
                      the Licence Fees are calculated based on the Licence Rate
                      and the length of the Clip (or partial Clip) you have
                      selected to download, rounded up to the nearest whole
                      second;
                    </li>
                    <li>
                      VuPop takes payment on behalf of the Licensor, so we
                      retain a portion of the Licence Fee (our “Broker’s Fee”)
                      and remit the balance to the relevant Licensor in
                      accordance with our App Terms; and
                    </li>
                    <li>
                      Licence Fees are billed and payable in accordance with
                      Clauses 4.4 to 4.6 below (as applicable).
                    </li>
                  </ul>
                </div>

                {/* Additional Editor Fees */}
                <div>
                  <h4 className="font-semibold text-gray-100 mb-2">
                    Additional Editor Fees
                  </h4>
                  <p>
                    <strong>4.2</strong> You acknowledge and agree that you will
                    be required to pay Additional Editor Fees in respect of any
                    Additional Editors you appoint. Additional Editor Fees are
                    billed and payable in accordance with Clauses 4.4 to 4.6
                    below (as applicable).
                  </p>
                </div>

                {/* Payment Terms */}
                <div>
                  <h4 className="font-semibold text-gray-100 mb-2">
                    Payment Terms
                  </h4>
                  <p>
                    <strong>4.3</strong> Payment terms depend on your chosen
                    Membership Tier so please read this section carefully.
                  </p>

                  <p className="mt-3">
                    <strong>4.4</strong> This clause applies only if you are
                    subscribed to the <em>'Social Tier'</em>. You hereby
                    authorise us to collect the Fees via your chosen payment
                    method (direct debit or card payment via our payment
                    processor) as nominated during the sign-up process. Subject
                    to Clause 4.7, payment will be taken in accordance with the
                    following deadlines:
                  </p>

                  <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2 marker:text-gray-300 marker:font-semibold">
                    <li>
                      Platform Fees are payable monthly in arrears. Platform
                      Fees will be taken:
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-1 marker:text-gray-300 marker:font-semibold">
                        <li>
                          on the first day of the calendar month after the
                          calendar month in which you sign up (pro-rated as
                          appropriate); and
                        </li>
                        <li>
                          thereafter monthly in arrears on the first day of each
                          calendar month throughout the Term.
                        </li>
                      </ul>
                    </li>
                    <li>
                      Licence Fees and any Additional Editor Fees will be taken
                      on the day on which they are incurred.
                    </li>
                  </ul>

                  <div className="ml-6 mt-3 space-y-2">
                    <p>
                      <strong>4.4.1</strong> Payment Processing: Card
                      payments are processed securely through our third-party
                      payment processor. By providing card details, you
                      authorise us to charge the payment method on file in
                      accordance with the payment schedule set out in this
                      Clause 4.4.
                    </p>
                    <p>
                      <strong>4.4.2</strong> Payment Method Changes: You
                      may update your payment method at any time through your
                      account settings. Changes to payment methods will take
                      effect from the next billing cycle.
                    </p>
                  </div>

                  <p className="mt-3">
                    <strong>4.5</strong> This clause applies only if you are
                    subscribed to the <em>'Enterprise Tier'</em> or{" "}
                    <em>'Broadcast Tier'</em>. All Fees will be invoiced monthly
                    in arrears:
                  </p>

                  <ul className="list-[lower-roman] ml-8 mt-2 space-y-1 marker:text-gray-300 marker:font-semibold">
                    <li>
                      on the first day of the calendar month after the calendar
                      month in which you sign up (with the first month’s
                      Platform Fees billed pro-rata); and
                    </li>
                    <li>
                      thereafter on the first day of each calendar month after
                      the month in which they were incurred.
                    </li>
                  </ul>

                  <p className="mt-3">
                    <strong>4.6</strong> All invoices issued to you by VuPop
                    must be paid in full and in cleared funds within thirty (30)
                    days of the date of the invoice.
                  </p>

                  <p className="mt-3">
                    <strong>4.7</strong> If any deadline for VuPop to perform an
                    obligation pursuant to Clause 4.4 or Clause 4.5 above falls
                    on a day other than a Business Day, or outside of business
                    hours, you acknowledge and agree that VuPop may perform such
                    obligation the following Business Day.
                  </p>

                  <p className="mt-3"> 
                    <strong>4.8</strong> Without prejudice to any other right or
                    remedy it might have, if you fail to pay (or fail to ensure
                    the payment to) VuPop of any sum due under this Agreement on
                    the due date for payment:
                  </p>
                  <ul className="list-[lower-roman] ml-8 mt-2 space-y-1 marker:text-gray-300 marker:font-semibold">
                    <li>
                      VuPop may charge you for any additional administration and
                      legal costs that VuPop may incur as a consequence of such
                      late payment;
                    </li>
                    <li>
                      VuPop may charge you interest (both before and after
                      judgment) on the amount unpaid at the rate of 4% p.a.
                      above the Bank of England’s base rate from time to time;
                      and
                    </li>
                    <li>
                      VuPop may, at its election, suspend the supply of all or
                      part of the Services under this Agreement until payment
                      has been made.
                    </li>
                  </ul>

                  <p className="mt-3">
                    <strong>4.9</strong> VuPop shall be entitled to set off or
                    withhold any amount owed to you under this Agreement against
                    any amount payable by you to VuPop.
                  </p>

                  <p className="mt-3">
                    <strong>4.10</strong> All sums payable to VuPop under this
                    Agreement:
                  </p>
                  <ul className="list-[lower-roman] ml-8 mt-2 space-y-1 marker:text-gray-300 marker:font-semibold">
                    <li>
                      are exclusive of VAT, which shall be payable by you in
                      addition at the rate and in the manner for the time being
                      prescribed by law;
                    </li>
                    <li>are non-cancellable and non-refundable; and</li>
                    <li>
                      shall be paid in full without any set-off, counterclaim,
                      deduction or withholding (other than any deduction or
                      withholding of tax as required by law).
                    </li>
                  </ul>

                  <p className="mt-3">
                    <strong>4.11</strong> VuPop shall be entitled to increase
                    the Fees no more than once per calendar year upon thirty
                    (30) days’ prior notice to you.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                5. LICENSEE OBLIGATIONS AND RESTRICTIONS
              </h3>

              <div className="space-y-6 text-gray-300">
                {/* 5.4 */}
                <div>
                  <p>
                    <strong>5.1</strong> You shall:
                  </p>

                  <ul className="list-[decimal] ml-8 mt-2 space-y-2 marker:text-gray-400">
                    <li>
                      without affecting your other obligations under this
                      Agreement, comply with all applicable laws and regulations
                      with respect to your activities under this Agreement, and
                      you shall procure that your Editors do likewise;
                    </li>
                    <li>
                      carry out all your responsibilities set out in this
                      Agreement in a timely and efficient manner, and in any
                      event, in accordance with any reasonable deadlines
                      specified by VuPop from time to time;
                    </li>
                    <li>
                      have sole responsibility for the legality, reliability,
                      integrity, accuracy and quality of all User Data;
                    </li>
                    <li>
                      be, to the extent permitted by law and except as otherwise
                      expressly provided in this Agreement, solely responsible
                      for procuring, maintaining and securing your network
                      connections and telecommunications links from your systems
                      to VuPop’s data centres, and for all problems, conditions,
                      delays, delivery failures and all other loss or damage
                      arising from or relating to your network connections or
                      telecommunications links or caused by the internet; and
                    </li>
                    <li>
                      notify VuPop immediately if you have reason to believe
                      that any Clip may:
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-1 marker:text-gray-400">
                        <li>
                          be unlawful, harmful, threatening, defamatory,
                          obscene, harassing or racially or ethnically
                          offensive;
                        </li>
                        <li>facilitate illegal activity;</li>
                        <li>depict sexually explicit images;</li>
                        <li>promote unlawful violence;</li>
                        <li>
                          be discriminatory based on race, gender, colour,
                          religious belief, sexual orientation, or disability;
                          or
                        </li>
                        <li>
                          infringe any third party rights (including
                          Intellectual Property rights, contractual rights and
                          rights to privacy);
                        </li>
                        <li>
                          have been recorded or created in an unlawful manner;
                          or
                        </li>
                        <li>
                          be otherwise illegal or cause damage or injury to any
                          person or property,
                        </li>
                      </ul>
                      <p className="mt-2 ml-2">
                        (any of sub-clauses (i) to (viii) above (inclusive)
                        being “Unlawful or Offensive Material”), or if you have
                        reason to believe that the Services are being used for
                        unlawful purposes (including fraud), and you shall
                        procure that your Editors do likewise.
                      </p>
                    </li>
                  </ul>
                </div>

                {/* 5.5 */}
                <div>
                  <p>
                    <strong>5.2</strong> You shall not, and you shall procure
                    that your Editors do not, access, store, distribute or
                    transmit any Viruses, or any Unlawful or Offensive Material
                    during the course of your or their use of the Services.
                  </p>
                </div>

                {/* 5.6 */}
                <div>
                  <p>
                    <strong>5.3</strong> You shall not, and you shall procure
                    that your Editors do not:
                  </p>

                  <ul className="list-[decimal] ml-8 mt-2 space-y-2 marker:text-gray-400">
                    <li>
                      except as may be permitted by this Agreement, by any
                      applicable Clip Terms, or by any mandatory provision of
                      applicable law:
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-1 marker:text-gray-400">
                        <li>
                          attempt to copy, modify, duplicate, create derivative
                          works from, frame, mirror, republish, download,
                          display, transmit, or distribute all or any portion of
                          the Services or the Clips in any form or media or by
                          any means; or
                        </li>
                        <li>
                          attempt to de-compile, reverse compile, disassemble,
                          reverse engineer or otherwise reduce to
                          human-perceivable form all or any part of the
                          Services;
                        </li>
                      </ul>
                    </li>
                    <li>
                      access all or any part of the Services in order to build a
                      product or service which competes with the Services;
                    </li>
                    <li>
                      license, sell, rent, lease, transfer, assign, distribute,
                      display, disclose, or otherwise commercially exploit, or
                      otherwise make the Services or the Clips available to any
                      third party (save as expressly permitted by any applicable
                      Clip Terms);
                    </li>
                    <li>
                      use the Services in a manner that VuPop determines, in its
                      sole discretion, to be excessive;
                    </li>
                    <li>
                      attempt to obtain, or assist third parties in obtaining,
                      unauthorised access to the Services or the Clips; or
                    </li>
                    <li>
                      introduce or permit the introduction of any Virus or
                      Vulnerability into the Services or VuPop’s network or
                      information systems.
                    </li>
                  </ul>
                </div>

                {/* 5.7 */}
                <div>
                  <p>
                    <strong>5.4</strong> If you have reason to believe that your
                    (and any of your Editors’) account details have been
                    accessed or used by anybody else, you shall notify VuPop and
                    procure that the relevant individual resets their password
                    immediately.
                  </p>
                </div>

                {/* 5.8 */}
                <div>
                  <p>
                    <strong>5.5</strong> You shall not during or for one year
                    after the Term of this Agreement approach any Licensees or
                    their Personnel directly with a view to completing any
                    transaction outside of the Services. All Clips that have
                    been sourced through VuPop must be licensed in accordance
                    with the Clip Terms.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                6. VUPOP’S PROVISION OF THE SERVICES
              </h3>

              <div className="space-y-6 text-gray-300">
                {/* 6.4 */}
                <div>
                  <p>
                    <strong>6.1</strong> Subject to the warranties at Clause
                    10.2, you acknowledge and agree that the Services and the
                    Clips are made available on an “as is” and “as available”
                    basis, and in particular that VuPop:
                  </p>

                  <ul className="list-[decimal] ml-8 mt-2 space-y-2 marker:text-gray-400">
                    <li>
                      does not warrant that:
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-1 marker:text-gray-400">
                        <li>
                          the Services or the Clips will always be available;
                        </li>
                        <li>
                          the Services or the Clips will be uninterrupted or
                          error-free;
                        </li>
                        <li>
                          the Services or the Clips will meet the Licensee’s
                          requirements; or
                        </li>
                        <li>
                          the Services or the Clips will be free from
                          Vulnerabilities or Viruses.
                        </li>
                      </ul>
                    </li>
                    <li>
                      is not responsible for any delays, delivery failures, or
                      any other loss or damage resulting from the transfer of
                      data over communications networks and facilities,
                      including the internet, and the Licensee acknowledges that
                      the Services may be subject to limitations, delays and
                      other problems inherent in the use of such communications
                      facilities.
                    </li>
                  </ul>
                </div>

                {/* 6.5 */}
                <div>
                  <p>
                    <strong>6.2</strong> If VuPop’s performance of any of its
                    obligations under this Agreement is prevented or delayed by
                    any act or omission of you or your Personnel, or by any
                    failure or delay by you or your Personnel to perform any
                    relevant obligation (“Licensee Default”):
                  </p>

                  <ul className="list-[decimal] ml-8 mt-2 space-y-2 marker:text-gray-400">
                    <li>
                      VuPop shall not be liable for:
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-1 marker:text-gray-400">
                        <li>
                          VuPop’s non-performance or delay (to the extent it was
                          caused by the Licensee Default); or
                        </li>
                        <li>
                          any costs or losses sustained or incurred by you
                          arising directly or indirectly from your Licensee
                          Default.
                        </li>
                      </ul>
                    </li>
                    <li>
                      you shall reimburse VuPop on written demand for any and
                      all costs or losses sustained or incurred by VuPop arising
                      directly or indirectly from any Licensee Default.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                7. DATA PROTECTION
              </h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>7.1</strong> For the purposes of this Agreement, the
                    words and phrases <strong>“controller”</strong>,{" "}
                    <strong>“data subjects”</strong> and{" "}
                    <strong>“personal data”</strong> shall have the meanings
                    given in the Data Protection Laws.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>7.2</strong> It is the Parties’ intention and
                    understanding that VuPop is a controller of any personal
                    data provided by the Licensee to VuPop.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>7.3</strong> The Parties shall comply with the Data
                    Protection Laws in relation to this Agreement. In
                    particular, the Licensee agrees that it will only provide
                    personal data to VuPop where it has all necessary rights to
                    do so, and where it has given all necessary notices to any
                    relevant data subjects. This Clause 7.3 is in addition to,
                    and does not relieve, remove or replace, either Party’s
                    obligations or rights under the Data Protection Laws.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                8. INTELLECTUAL PROPERTY RIGHTS
              </h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>8.1</strong> The Parties acknowledge and agree that:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        VuPop and/or its licensors own all Intellectual Property
                        rights in the Services, and except as expressly stated
                        herein, this Agreement does not grant you any rights to,
                        under or in the Services or any Intellectual Property
                        rights therein; and
                      </p>
                    </li>
                    <li>
                      <p>
                        each Licensor and/or its licensors own all Intellectual
                        Property rights in the Clips, and except as expressly
                        stated in this Agreement or any Clip Terms, you do not
                        acquire any rights to, under or in the Clips or any
                        Intellectual Property rights therein.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>8.2</strong> You hereby grant VuPop a fully paid-up,
                    non-exclusive, royalty-free, worldwide, perpetual,
                    irrevocable, transferable licence to:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        use any User Data for any purpose (including the
                        creation of Derived Data); and
                      </p>
                    </li>
                    <li>
                      <p>
                        use or incorporate any feedback you provide into our
                        products and/or services.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>8.3</strong> You acknowledge and agree that, subject
                    to Clause 8.1(b), VuPop will own all new Intellectual
                    Property rights created by VuPop or on VuPop’s behalf:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>in any Derived Data; and</p>
                    </li>
                    <li>
                      <p>in VuPop’s performance of the Services.</p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>8.4</strong> You shall not use any trade mark,
                    copyright, branding elements, or other Intellectual Property
                    rights of VuPop without VuPop’s prior written consent,
                    unless you are entitled to do so under applicable law.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>8.5</strong> All rights not expressly granted by
                    this Agreement are reserved.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                9. CONFIDENTIALITY
              </h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>9.1</strong> Subject to Clause 9.2, VuPop will hold
                    all information that the Licensee has provided and has
                    either marked as confidential or is notified to VuPop as
                    being confidential (“Licensee Confidential Information”) in
                    the strictest confidence, and VuPop will not disclose any
                    such content or information to any other person, company or
                    organisation.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>9.2</strong> The confidentiality obligations in
                    Clause 9.1 shall not apply:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        to any disclosures that VuPop is required to make by
                        law, by a court of competent jurisdiction, or by any
                        regulatory body;
                      </p>
                    </li>
                    <li>
                      <p>
                        to information that has come into the public domain
                        through no fault of VuPop, or that the Licensee has made
                        part of its visible profile on the Licensee Services;
                      </p>
                    </li>
                    <li>
                      <p>
                        to information that VuPop develops independently
                        (without benefit of the Licensee Confidential
                        Information) or receives from a third party (which is
                        not in breach of a continuing obligation of
                        confidentiality to the Licensee); or
                      </p>
                    </li>
                    <li>
                      <p>in respect of VuPop’s right to share:</p>
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-2">
                        <li>
                          <p>
                            the Licensee Confidential Information with its
                            Personnel, who will each be informed of the
                            confidential nature of the Licensee Confidential
                            Information and instructed to treat such information
                            confidentially; and
                          </p>
                        </li>
                        <li>
                          <p>
                            the Licensee’s identity with any Licensor in
                            connection with any Clip Terms.
                          </p>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>9.3</strong> Subject to Clause 9.4, the Licensee
                    will hold all VuPop Confidential Information in the
                    strictest confidence. “VuPop Confidential Information” means
                    anything provided by or on behalf of VuPop that is marked as
                    confidential, is notified to the Licensee as being
                    confidential or that could reasonably be considered to be
                    confidential. The Parties agree that VuPop Confidential
                    Information includes:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        any information relating to VuPop’s business, affairs,
                        strategies, suppliers, Personnel, software (including
                        the Services), operations, processes, prices and pricing
                        models, Broker’s Fees, products, services and
                        Intellectual Property;
                      </p>
                    </li>
                    <li>
                      <p>
                        the contents of the Vault (save to the extent that you
                        have licensed a Clip pursuant to the Clip Terms); and
                      </p>
                    </li>
                    <li>
                      <p>
                        any personal data accessed and/or processed by the
                        Licensee’s Personnel.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>9.4</strong> The confidentiality obligations in
                    Clause 9.3 shall not apply to:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        any disclosures that the Licensee is required to make by
                        law, by a court of competent jurisdiction, or by any
                        regulatory body, but only to the minimum extent
                        required, and provided that the Licensee first notifies
                        VuPop of the requirement (if not prohibited by
                        applicable law) and, upon the request of VuPop, the
                        Licensee shall use commercially reasonable efforts to
                        assist VuPop, at VuPop’s sole expense, in seeking an
                        appropriate protective order;
                      </p>
                    </li>
                    <li>
                      <p>
                        information that has come into the public domain through
                        no fault of the Licensee;
                      </p>
                    </li>
                    <li>
                      <p>
                        information that the Licensee develops independently
                        (without benefit of VuPop Confidential Information) or
                        receives from a third party (which is not in breach of a
                        continuing obligation of confidentiality to VuPop); and
                      </p>
                    </li>
                    <li>
                      <p>
                        the Licensee’s right to share the VuPop Confidential
                        Information with its Personnel, who will each be
                        informed of the confidential nature of the VuPop
                        Confidential Information and instructed to treat such
                        information confidentially, and the Licensee shall be
                        liable to VuPop if any such Party should fail to comply
                        with the terms of such confidentiality obligation.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>9.5</strong> Neither Party shall use the other
                    Party’s Confidential Information for any purpose other than
                    to perform its obligations and exercise its rights under
                    this Agreement or any related agreement.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>9.6</strong> No Party shall make, or permit any
                    person to make, any public announcement concerning this
                    Agreement without the prior written consent of the other
                    Party (such consent not to be unreasonably withheld or
                    delayed), except as required by law, any governmental or
                    regulatory authority (including, without limitation, any
                    relevant securities exchange), any court or other authority
                    of competent jurisdiction.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                10. WARRANTIES AND INDEMNITIES
              </h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>10.1</strong> Each Party warrants to the other that
                    it has the full power, capacity and authority to enter into
                    this Agreement and to perform its obligations under this
                    Agreement.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>10.2</strong> VuPop warrants and undertakes that:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        it has and will maintain during the Term all licences,
                        consents, and permissions necessary for the performance
                        of its obligations under this Agreement; and
                      </p>
                    </li>
                    <li>
                      <p>
                        all Clips that it delivers pursuant to Clause 3.2 will
                        be:
                      </p>
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-2">
                        <li>
                          <p>
                            formatted in accordance with your Chosen Settings;
                          </p>
                        </li>
                        <li>
                          <p>
                            delivered in accordance with the timescales set out
                            at Clause 3.3; and
                          </p>
                        </li>
                        <li>
                          <p>
                            free from any technical bugs or technical errors.
                          </p>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>10.3</strong> You hereby warrant, represent and
                    undertake that:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        you shall obtain and shall maintain all necessary
                        licences, consents, and permissions necessary for:
                      </p>
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-2">
                        <li>
                          <p>you to provide the User Data to VuPop;</p>
                        </li>
                        <li>
                          <p>
                            VuPop, its contractors and agents to use the User
                            Data in accordance with this Agreement; and
                          </p>
                        </li>
                        <li>
                          <p>any use you choose to make of any Clips;</p>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <p>
                        your receipt and use of the Services shall be for
                        legitimate business purposes and in compliance with all
                        applicable laws and regulations; and
                      </p>
                    </li>
                    <li>
                      <p>
                        the receipt and use of the User Data in the performance
                        of this Agreement by VuPop and its Personnel does not,
                        and shall not, infringe the rights, including any
                        Intellectual Property rights, of any third party.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>10.4</strong> The Licensee will hold VuPop harmless
                    from, and indemnify VuPop on demand and keep VuPop fully and
                    effectively indemnified from and against, all costs,
                    expenses, damages and losses, including any interest, fines,
                    legal and other professional fees and expenses awarded
                    against or incurred or paid by VuPop, and any sums agreed to
                    in settlement, as a result of, or in connection with:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>your actual or alleged breach of Clause 10.3;</p>
                    </li>
                    <li>
                      <p>your receipt and/or use of any Clips; and</p>
                    </li>
                    <li>
                      <p>
                        any Clip Terms you have (or are alleged to have, or
                        purport to have) entered into.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>10.5</strong> If any third party makes a claim, or
                    notifies VuPop that it is intending to make a claim, against
                    VuPop, which may reasonably be considered to be likely to
                    give rise to a liability under an indemnity given under
                    Clause 10.4 of this Agreement, VuPop will give the Licensee
                    written notice of such claim and allow the Licensee to have
                    sole authority to dispute, compromise or defend such claim
                    with the assistance of VuPop as reasonably requested by the
                    Licensee (and the Licensee agrees to reimburse VuPop in full
                    for all such assistance).
                  </p>
                </div>

                <div>
                  <p>
                    <strong>10.6</strong> Except as expressly and specifically
                    provided in this Agreement:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        you assume sole responsibility for your use of the
                        Services, and for any reliance placed on such use;
                      </p>
                    </li>
                    <li>
                      <p>VuPop shall have no liability for:</p>
                      <ul className="list-[lower-roman] ml-6 mt-2 space-y-2">
                        <li>
                          <p>
                            any Clips in our Vault, nor any claims or statements
                            made by any Licensor in relation to any Clip;
                          </p>
                        </li>
                        <li>
                          <p>
                            any Clips you have licensed from a Licensor, or any
                            ways you have used (or are alleged to have used) any
                            such Clips;
                          </p>
                        </li>
                        <li>
                          <p>any disputes in relation to the Clip Terms;</p>
                        </li>
                        <li>
                          <p>
                            any loss or damage caused by errors, faults or
                            omissions in any User Data you provide to VuPop
                            and/or any Licensors in connection with the
                            Services;
                          </p>
                        </li>
                        <li>
                          <p>
                            any use of the Services in breach of this Agreement
                            or contrary to VuPop’s instructions from time to
                            time;
                          </p>
                        </li>
                        <li>
                          <p>
                            modification or alteration of the Services by any
                            party other than VuPop or VuPop’s duly authorised
                            contractors or agents; or
                          </p>
                        </li>
                        <li>
                          <p>
                            any actions taken by VuPop at your direction; and
                          </p>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <p>
                        all warranties, representations, conditions and all
                        other terms of any kind whatsoever implied by statute or
                        common law are, to the fullest extent permitted by
                        applicable law, excluded from this Agreement.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                12. TERM AND TERMINATION
              </h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>12.1</strong> This Agreement shall commence on the
                    Effective Date and shall continue for an initial term of
                    twelve (12) months (the “Initial Term”). After the Initial
                    Term, this Agreement shall automatically renew for
                    subsequent 12-month periods (each a “Renewal Term”) unless
                    and until:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        either Party gives the other Party at least thirty (30)
                        days’ written notice of termination, such notice to take
                        effect upon the expiry of the Initial Term or any
                        Renewal Term (as applicable); or
                      </p>
                    </li>
                    <li>
                      <p>
                        this Agreement is otherwise terminated in accordance
                        with its terms,
                      </p>
                    </li>
                  </ul>
                  <p className="ml-6 mt-2">
                    whichever occurs first (the “Term”).
                  </p>
                </div>

                <div>
                  <p>
                    <strong>12.2</strong> Either Party may terminate this
                    Agreement immediately by written notice if the other Party:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        commits any material or persistent breach of any of its
                        obligations under this Agreement or any other Agreement
                        between the Parties and, in the case of a breach which
                        is capable of remedy, fails to remedy it within thirty
                        (30) days of being required to do so by notice in
                        writing from the other Party;
                      </p>
                    </li>
                    <li>
                      <p>
                        is unable to pay its debts within the meaning of section
                        123 of the Insolvency Act 1986;
                      </p>
                    </li>
                    <li>
                      <p>
                        has a receiver, administrator, administrative receiver
                        or trustee in bankruptcy appointed over it or over any
                        part of its undertaking or assets, or if it passes a
                        resolution for winding-up (except for the purpose of a
                        bona fide scheme of solvent amalgamation or
                        reconstruction) or if a court of competent jurisdiction
                        makes an order to that effect;
                      </p>
                    </li>
                    <li>
                      <p>
                        becomes subject to an administration order or if it
                        enters into any voluntary agreement with its creditors;
                      </p>
                    </li>
                    <li>
                      <p>
                        goes into liquidation (except for the purposes of
                        solvent amalgamation or a solvent reconstruction and in
                        such manner, that the company resulting therefrom
                        effectively agrees to be bound by or assume the
                        obligations imposed on the other party); or
                      </p>
                    </li>
                    <li>
                      <p>
                        becomes subject to any analogous or similar process to
                        any of the above in any jurisdiction, or if it ceases or
                        threatens to cease to carry on business.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>12.3</strong> VuPop may terminate this Agreement
                    and/or suspend the supply of all or part of the Services
                    with immediate effect by giving notice to the Licensee if
                    there is a change of Control of the Licensee.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>12.4</strong> On termination or expiry of this
                    Agreement for any reason:
                  </p>
                  <ul className="list-[decimal] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        all licences granted to the Licensee under this
                        Agreement shall immediately terminate (but any executed
                        Clip Terms will not be affected);
                      </p>
                    </li>
                    <li>
                      <p>
                        the Licensee shall immediately cease all use of the
                        Services and the Documentation;
                      </p>
                    </li>
                    <li>
                      <p>
                        each Party shall return and make no further use of any
                        equipment, property, Documentation and other items (and
                        all copies of them) belonging to the other Party;
                      </p>
                    </li>
                    <li>
                      <p>
                        any amounts due and owing to VuPop by you under this
                        Agreement shall become immediately payable; and
                      </p>
                    </li>
                    <li>
                      <p>
                        any rights, remedies, obligations or liabilities of the
                        Parties that have accrued up to the date of termination,
                        including the right to claim damages in respect of any
                        breach of the Agreement which existed at or before the
                        date of termination shall not be affected or prejudiced.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>12.5</strong> Any provision of this Agreement which
                    expressly, or by implication, is intended to come into or
                    continue in effect on or after termination or expiry
                    (including, without limitation, Clauses 1, 3.4, 4.1 to 4.9
                    (inclusive), 5.1(c), 5.1(d), 5.3, 6, 7, 8, 9, 10, 11, 12.4,
                    13.1, 14 and 15) shall remain in full force and effect.
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                13. FORCE MAJEURE
              </h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>13.1</strong> Neither Party shall be liable to the
                    other for any delay or non-performance of its obligations
                    under this Agreement (other than an obligation to pay the
                    Fees) arising from any cause or causes beyond its reasonable
                    control, including, but not limited to:
                  </p>
                  <ul className="list-[lower-alpha] ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        any Services not being available due to mechanical
                        breakdown, maintenance, hardware or software upgrades,
                        telecommunication connectivity problems, outages from
                        cloud providers, power shortage, network failure, server
                        crashes, deletion, corruption, or loss or removal of
                        data;
                      </p>
                    </li>
                    <li>
                      <p>
                        either Party ceasing to have access to the Internet for
                        any reason;
                      </p>
                    </li>
                    <li>
                      <p>
                        any fire, explosion, storm, flood, tempest, drought,
                        earthquake, accident or pandemic;
                      </p>
                    </li>
                    <li>
                      <p>war, hostilities, riots or acts of terrorism;</p>
                    </li>
                    <li>
                      <p>failure of utility supply;</p>
                    </li>
                    <li>
                      <p>failure of computer systems;</p>
                    </li>
                    <li>
                      <p>labour dispute; or</p>
                    </li>
                    <li>
                      <p>
                        any act or omission (including changes to laws or
                        regulations or any disapprovals or failures to approve)
                        of any government, government agency or authorised body
                        (a “Force Majeure Event”).
                      </p>
                    </li>
                  </ul>
                  <p className="mt-2 ml-6">
                    The Party subject to a Force Majeure Event shall promptly
                    notify the other Party of that fact and will use its
                    reasonable endeavours to minimise the impact of such Force
                    Majeure Event.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>13.2</strong> If a Party is prevented from
                    performing its obligations under this Agreement in relation
                    to any of the Services by a Force Majeure Event which
                    continues for more than ninety (90) days, then either Party
                    will be entitled to terminate this Agreement on written
                    notice with immediate effect and without liability to the
                    other Party.
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                14. DISPUTES
              </h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>14.1</strong> If a dispute arises out of, or in
                    connection with, this Agreement or the performance, validity
                    or enforceability of it (a “Dispute”), then except as
                    expressly provided in this Agreement, the Parties must
                    follow the procedure set out in this clause before
                    commencing court proceedings:
                  </p>

                  <ul className="list-decimal ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        Either Party shall give to the other written notice of
                        the Dispute, setting out its nature and full particulars
                        (a “Dispute Notice”), together with relevant supporting
                        documents. On service of the Dispute Notice, a
                        representative of each Party shall attempt in good faith
                        to resolve the Dispute.
                      </p>
                    </li>
                    <li>
                      <p>
                        If the Licensee and the VuPop representative are for any
                        reason unable to resolve the Dispute within fourteen
                        (14) days of service of the Dispute Notice, the Dispute
                        shall be referred to a senior management representative
                        of each Party (and, in the case of a Licensee that is an
                        organisation, a senior representative of that
                        organisation), and the Parties shall attempt in good
                        faith to resolve the Dispute for not less than fourteen
                        (14) days.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>14.2</strong> The Parties agree that nothing in this
                    Agreement shall waive, preclude, or otherwise limit their
                    rights to apply to the Courts of England and Wales to:
                  </p>
                  <ul className="list-[lower-roman] ml-8 mt-2 space-y-2">
                    <li>
                      <p>pursue enforcement of an arbitrator’s award; or</p>
                    </li>
                    <li>
                      <p>seek injunctive or other interim relief.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">15. GENERAL</h3>

              <div className="space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>15.1</strong> The Licensee shall not during the
                    Term, nor for a period of twelve (12) months following the
                    termination or expiry of this Agreement for any reason, on
                    its own behalf or on behalf of any third party, directly
                    induce, or attempt to induce, any person employed by VuPop
                    who has been engaged in the provision of the Services to the
                    Licensee to leave the employment of VuPop or employ or
                    engage in any capacity any such employee, provided that this
                    restriction shall not apply to any such person who makes an
                    unsolicited reply to a bona fide public advertisement,
                    including by the Licensee on its website, or solicitations
                    conducted by an entity that is acquired by or merged with
                    the Licensee, so long as such solicitations were conducted
                    prior to the date of such acquisition or merger.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.2</strong> VuPop may at any time assign,
                    mortgage, charge, subcontract, delegate, declare a trust
                    over or deal in any other manner with any or all of its
                    rights and obligations under this Agreement.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.3</strong> You shall not assign, transfer,
                    mortgage, charge, subcontract, declare a trust over or deal
                    in any other manner with any of your rights and obligations
                    under the Agreement without the prior written consent of
                    VuPop.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.4</strong> The Services are provided for the sole
                    benefit of the Licensee, unless expressly agreed otherwise
                    by the Parties and set out in writing.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.5</strong> VuPop is an independent contractor to
                    the Licensee and shall not be deemed to be a partner of, or
                    otherwise associated with, the Licensee in any way.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.6</strong> This Agreement shall be governed by
                    the laws of England and Wales and shall (subject to Clause
                    14) be subject to the exclusive jurisdiction of the Courts
                    of England and Wales.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.7</strong> This Agreement constitutes the entire
                    agreement between the Parties relating to the matters
                    provided for herein and supersedes all previous agreements,
                    understandings or arrangements between the Parties relating
                    to these matters. Each of the Parties acknowledges and
                    agrees that in entering into the Agreement it does not rely
                    on, and will have no remedy in respect of, any statement,
                    representation, warranty or understanding (whether
                    negligently or innocently made) of any person (whether Party
                    to the Agreement or not) other than as expressly set out in
                    the Agreement. Nothing in this Clause shall limit or exclude
                    any liability for fraud.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.8</strong> A waiver of any right or remedy is
                    only effective if given in writing. A delay or failure to
                    exercise, or the single or partial exercise of, any right or
                    remedy shall not waive that or any other right or remedy,
                    nor shall it prevent or restrict the further exercise of
                    that or any other right or remedy.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.9</strong> Except as expressly provided in this
                    Agreement, the rights and remedies provided under this
                    Agreement are in addition to, and not exclusive of, any
                    rights or remedies provided by law.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.10</strong> Any notices to be given under this
                    Agreement shall, unless otherwise expressly stated, be in
                    writing and shall be given by sending the same by email.
                    Notices shall be delivered:
                  </p>
                  <ul className="list-decimal ml-6 mt-2 space-y-2">
                    <li>
                      <p>
                        if to the Licensee, to the email address associated with
                        the Licensee’s account; and
                      </p>
                    </li>
                    <li>
                      <p>
                        if to VuPop, to{" "}
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(
                              "https://mail.google.com/mail/?view=cm&fs=1&to=contact@vupop.io",
                              "_blank"
                            );
                          }}
                          className="underline cursor-pointer text-blue-400 hover:text-blue-300"
                        >
                          contact@vupop.io
                        </a>{" "}
                        or such other email address as VuPop may notify to the
                        Licensee in writing from time to time during the Term.
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>15.11</strong> Any notice by email shall be deemed
                    to have been delivered on the same day (if sent during
                    Normal Working Hours), and if sent outside of Normal Working
                    Hours, at 9am on the next Business Day. Clauses 15.10 and
                    15.11 do not apply to the service of any proceedings or
                    other documents in any legal action or, where applicable,
                    any other method of dispute resolution.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.12</strong> A person who is not a party to this
                    Agreement shall have no rights under the Contracts (Rights
                    of Third Parties) Act 1999 to enforce any of its terms.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.13</strong> This Agreement may be executed in any
                    number of counterparts, each of which when executed shall
                    constitute a duplicate original, but all the counterparts
                    shall together constitute the one agreement.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.14</strong> The invalidity or unenforceability of
                    any provision, part-provision or any right arising under
                    this Agreement shall not affect the validity or
                    enforceability of any other provisions or rights. If any
                    provision or part-provision is adjudged to be invalid or
                    unenforceable, the relevant provisions shall apply with such
                    deletions or modifications as may be necessary to make them
                    valid and effective.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.15</strong> If any provision or part-provision of
                    this Agreement is deemed deleted under Clause 15.14, the
                    Parties shall negotiate in good faith to agree a replacement
                    provision that, to the greatest extent possible, achieves
                    the intended commercial result of the original provision.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-700 text-center text-yellow-400">
            <p>Last updated: 9 October 2025</p>
          </div>
        </div>
      </div>

      {/* Schedule 1 – Clip Terms */}
      <div className="max-w-4xl mx-auto bg-[#1B1B1C] rounded-lg shadow-lg overflow-hidden mt-10">
        {/* Header */}
        <div className="bg-black text-yellow-400 px-6 py-6 border-b border-gray-700">
          <h2 className="text-2xl font-bold text-center">SCHEDULE 1</h2>
          <p className="text-yellow-300 text-center text-lg mt-1">Clip Terms</p>
        </div>

        {/* Body */}
        <div className="px-6 py-8 text-gray-300 space-y-6">
          <p className="leading-relaxed">
            This agreement (the <strong>“Agreement”</strong>) is between:
          </p>

          <ol className="list-decimal ml-6 space-y-3">
            <li>
              <p>
                The VuPop user that has provided and agreed to license the Clip
                (the <strong>“Licensor”</strong>); and
              </p>
            </li>
            <li>
              <p>
                The VuPop user that wishes to take a license to the Clip in
                exchange for the Clip Fee (the <strong>“Licensee”</strong>),
              </p>
            </li>
          </ol>

          <p>each a “Party” and together the “Parties”.</p>

          <div className="bg-[#434345] p-6 rounded-lg border-l-4 border-black mt-6">
            <p className="font-semibold text-gray-300 mb-3">
              By clicking or tapping any button or box marked “accept”, “agree”
              or “ok” (or a similar term) referencing this Agreement, the
              Parties confirm that:
            </p>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span>
                  they are bound by this Agreement with respect to each Clip
                  licensing transaction;{" "}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span>
                  if an individual, they are of legal age where they live; and
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-black font-bold mr-2">•</span>
                <span>
                  they have the legal capacity to enter into this Agreement,
                  either as an individual or as an authorised representative of
                  their company(ies).
                </span>
              </li>
            </ul>
          </div>
          <div className="mt-6 p-4 bg-yellow-100 rounded-lg">
            <p className="text-gray-700">
              <strong>
                Each Party should print and keep a copy of this Agreement for
                future reference.
              </strong>
            </p>
            <p className="text-gray-700 mt-2">
              <strong>
                Each Party’s attention is drawn in particular to the warranties,
                indemnities and limitations of liability in Clauses 5.2, 9 and
                10.
              </strong>
            </p>
          </div>

          <h3 className="text-yellow-400 font-semibold text-lg mt-6">
            BACKGROUND
          </h3>

          <ol className="list-[upper-alpha] ml-6 space-y-3 mt-3">
            <li>
              <p>
                The Licensor has made the Clip (as defined below) available via
                the VuPop Vault (as defined below) and has agreed to license the
                Clip on the terms of this Agreement.
              </p>
            </li>
            <li>
              <p>
                The Licensor wishes to take a licence to the Clip on the terms
                of this Agreement.
              </p>
            </li>
          </ol>
{/* AGREED TERMS Section */}
<div className="mb-8 mt-10">
  {/* Header */}
  <div className="bg-black text-yellow-400 px-4 py-3 rounded-t-lg">
    <h2 className="text-xl font-bold uppercase tracking-wide">
      AGREED TERMS
    </h2>
  </div>

  {/* Clause 1 */}
  <div className="border border-gray-700 rounded-b-lg p-6">
    <h3 className="text-xl font-bold text-white mb-4">
      1. DEFINITIONS AND INTERPRETATION
    </h3>

    <div className="mb-6 ml-4 space-y-4 text-gray-300">
      <h4 className="font-semibold text-gray-300 mb-3">
        1.1 The definitions and rules of interpretation in this Clause apply to these Terms.
      </h4>

      <div className="ml-4 space-y-4">
        <div>
          <p>
            <strong>“App”</strong> means the VuPop mobile app which allows licensors to upload clips.
          </p>
        </div>
        <div>
          <p>
            <strong>“App Terms”</strong> means the terms and conditions between the Licensor and VuPop in relation to the VuPop App.
          </p>
        </div>
        <div>
          <p>
            <strong>“Business Day”</strong> means a day other than a Saturday, Sunday or public holiday in England when banks in London are open for business.
          </p>
        </div>
        <div>
          <p>
            <strong>“Chosen Settings”</strong> means the specifications set by the Licensee in their use of the VuPop Licensee Services.
          </p>
        </div>
        <div>
          <p>
            <strong>“Clip”</strong> means the digital video or image file with the Clip ID shown at the top of this Agreement (or part of such file), formatted in accordance with the Licensee’s Chosen Settings.
          </p>
        </div>
        <div>
          <p>
            <strong>“Clip ID”</strong> means the code generated by the Website or the App that identifies each specific Clip licensed under the terms of this Agreement.
          </p>
        </div>
        <div>
          <p>
            <strong>“Data Protection Laws”</strong> mean all applicable laws in relation to data protection, privacy, interception and monitoring of communications, or requirements relating to the processing of personal data of any kind.
          </p>
        </div>
        <div>
          <p>
            <strong>“Dispute”</strong> has the meaning given in Clause 12.1.
          </p>
        </div>
        <div>
          <p>
            <strong>“Dispute Notice”</strong> has the meaning given in Clause 12.1(a).
          </p>
        </div>
        <div>
          <p>
            <strong>“Effective Date”</strong> means the date on which this Agreement is agreed by the Licensee.
          </p>
        </div>
        <div>
          <p>
            <strong>“Intellectual Property”</strong> means patents, copyright, trademarks, trade names, rights in get-up, goodwill, designs, know-how, trade secrets, and any other intellectual property rights existing now or in the future.
          </p>
        </div>
        <div>
          <p>
            <strong>“Licence Fee”</strong> means the fee paid by the Licensee to license the Clip under this Agreement.
          </p>
        </div>
        <div>
          <p>
            <strong>“Normal Working Hours”</strong> mean 9.00 am to 5.00 pm UK time, each Business Day.
          </p>
        </div>
        <div>
          <p>
            <strong>“Permitted Sub-Licensee”</strong> means any person or entity agreed in writing by the Licensee and VuPop to be a ‘Permitted Sub-Licensee’ of the Clip.
          </p>
        </div>
        <div>
          <p>
            <strong>“Personnel”</strong> means a Party’s directors, officers, partners, principals, employees, agents, consultants, and subcontractors.
          </p>
        </div>
        <div>
          <p>
            <strong>“Term”</strong> means the period commencing on the Effective Date and continuing indefinitely until the Licensee ceases to maintain a Valid Licence.
          </p>
        </div>
        <div>
          <p>
            <strong>“Valid Licence”</strong> means a valid and subsisting, fee-paying licence to use the VuPop Licensee Services.
          </p>
        </div>
        <div>
          <p>
            <strong>“VAT”</strong> means Value Added Tax, as defined by the Value Added Tax Act 1994.
          </p>
        </div>
        <div>
          <p>
            <strong>“Video-On-Demand Services”</strong> means a service where content is made available on demand for personal and non-commercial viewing.
          </p>
        </div>
        <div>
          <p>
            <strong>“VuPop”</strong> means Social On Air Limited, registered in England and Wales (No. 15140619) with its registered office at 11a Abbey Road, Malvern, England, WR14 3ES.
          </p>
        </div>
        <div>
          <p>
            <strong>“VuPop Licensee Services”</strong> means the software, content and materials (other than the Clips) and services made available at the Website.
          </p>
        </div>
        <div>
          <p>
            <strong>“VuPop Licensee Terms”</strong> means the terms and conditions between the Licensee and VuPop in relation to the VuPop Licensee Services.
          </p>
        </div>
        <div>
          <p>
            <strong>“VuPop Vault”</strong> means the library of clips which are available to license as part of the VuPop Licensee Services.
          </p>
        </div>
        <div>
          <p>
            <strong>“Virus”</strong> means any software or code that impairs or adversely affects system operation, data, or user experience.
          </p>
        </div>
        <div>
          <p>
            <strong>“Vulnerability”</strong> means a weakness in software or hardware components that, when exploited, negatively impacts confidentiality, integrity, or availability.
          </p>
        </div>
        <div>
          <p>
            <strong>“Website”</strong> means VuPop website at{" "}
            <a
              href="https://www.vupop.io"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-blue-400"
            >
              www.vupop.io
            </a>{" "}
            (or any successor URL).
          </p>
        </div>
      </div>

      {/* Sub-clauses */}
      <div className="mt-6 space-y-2">
        <p><strong>1.2</strong> Clause, schedule and paragraph headings are for convenience only and do not affect interpretation.</p>
        <p><strong>1.3</strong> References to Clauses are to the clauses of these Terms.</p>
        <p><strong>1.4</strong> A person includes an individual, corporate or unincorporated body and their successors or permitted assigns.</p>
        <p><strong>1.5</strong>A reference to a company includes any corporation or body corporate, wherever incorporated.</p>
        <p><strong>1.6</strong>Words in the singular include the plural and vice versa; references to gender include all genders and none.</p>
        <p><strong>1.7</strong>References to statutes include all amendments and subordinate legislation.</p>
        <p><strong>1.8</strong>Words following “including”, “in particular” or similar shall be illustrative only.</p>
        <p><strong>1.9</strong>An obligation not to do something includes not allowing it to be done.</p>
        <p><strong>1.10</strong> “Writing” includes email but not fax.</p>
      </div>
    </div>
  </div>
</div>


  <div className="border border-gray-700 rounded-b-lg p-6">
    <h3 className="text-xl font-bold text-white mb-4">
      2. Licence Grant
    </h3>
    <p className="text-gray-300 mb-4">
      <strong>2.1 </strong>The Licensor hereby grants to the Licensee a non-exclusive,
      non-transferrable, non-sub-licensable (save as permitted by Clause 2.3),
      worldwide licence during the Term to:
    </p>

    {/* Lower-alpha list */}
    <ol className="list-[lower-alpha] ml-6 space-y-3 text-gray-300">
      <li>
        store, copy and view the Clip;
      </li>
      <li>
        show, play and communicate the Clip:
        <ol className="list-[lower-roman] ml-6 mt-2 space-y-2">
          <li>as a graphic work;</li>
          <li>via broadcast television or radio;</li>
          <li>via social media; and</li>
          <li>via Video-On-Demand services;</li>
        </ol>
      </li>
      <li>
        create adaptations of the Clip (<strong>“Adaptations”</strong>); and
      </li>
      <li>
        undertake the activities listed at 2.1(a) to 2.1(b) above in relation to
        any Adaptations,
      </li>
    </ol>

    <p className="text-gray-300 mt-3 ">
      in each case subject to, and in accordance with, the terms of this Agreement.
    </p>

    {/* Clause 2.2 */}

    <p className="text-gray-300 mb-3 mt-1"><strong >2.2 </strong> The Licensee may not:</p>
    <ol className="list-[lower-alpha] ml-6 space-y-2 text-gray-300">
      <li>rent or lend the Clip; nor</li>
      <li>
        make the Clip available for permanent storage (including but not limited
        to download and/or remote digital storage) and/or indefinite playback.
      </li>
    </ol>

    {/* Clause 2.3 */}
    
    <p className="text-gray-300 mt-1">
      <strong>2.3 </strong>The Licensee may sub-license its rights under Clause 2.1 above to the
      Permitted Sub-Licensees only, but provided always that the Licensee does
      not receive any fee, payment, consideration or benefit in kind for such
      sub-licence.
    </p>
  </div>

{/* Clause 3 – LICENCE FEES */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">3. LICENCE FEES</h3>

  <div className="space-y-4 text-gray-300">
    {/* 3.1 */}
    <div>
      <p>
        <strong>3.1</strong> The Parties agree that:
      </p>
      <ul className="list-[lower-alpha] ml-6 mt-2 space-y-2">
        <li>
          <p>
            The Licensee shall pay the Licence Fee to VuPop in accordance with
            the VuPop Licensee Terms; and
          </p>
        </li>
        <li>
          <p>
            The Licensor shall be entitled to receive a portion of the Licence
            Fee in accordance with, and subject to, the App Terms.
          </p>
        </li>
      </ul>
    </div>

    {/* 3.2 */}
    <div>
      <p>
        <strong>3.2</strong> All sums payable by the Licensee under this
        Agreement:
      </p>
      <ul className="list-[lower-alpha] ml-6 mt-2 space-y-2">
        <li>
          <p>
            Are exclusive of VAT, which shall be payable by the Licensee in
            addition at the rate and in the manner for the time being prescribed
            by law;
          </p>
        </li>
        <li>
          <p>Are non-cancellable and non-refundable; and</p>
        </li>
        <li>
          <p>
            Shall be paid in full without any set-off, counterclaim, deduction
            or withholding (other than any deduction or withholding of tax as
            required by law).
          </p>
        </li>
      </ul>
    </div>

    {/* 3.3 */}
    <div>
      <p>
        <strong>3.3</strong> The Licensee acknowledges and agrees the Licence
        Fee is specific to the relevant Clip, formatted in accordance with its
        Chosen Settings, and if the Licensee wishes to download any Clip with
        different Chosen Settings, an additional Licence Fee will apply.
      </p>
    </div>
  </div>
</div>
{/* Clause 4 – OBLIGATIONS AND RESTRICTIONS */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">
    4. OBLIGATIONS AND RESTRICTIONS
  </h3>

  <div className="space-y-4 text-gray-300">
    {/* 4.1 */}
    <div>
      <p>
        <strong>4.1</strong> The Licensee shall not:
      </p>
      <ul className="list-[lower-alpha] ml-6 mt-2 space-y-2">
        <li>
          <p>
            Except as may be permitted by this Agreement:
          </p>
          <ul className="list-[lower-roman] ml-6 mt-2 space-y-2">
            <li>
              <p>
                Attempt to copy, modify, duplicate, create derivative works
                from, frame, mirror, republish, download, display, transmit, or
                distribute all or any portion of the Clip in any form or media
                or by any means; or
              </p>
            </li>
            <li>
              <p>
                License, sell, rent, lease, transfer, assign, distribute,
                display, disclose, or otherwise commercially exploit, or
                otherwise make the Clip available to any third party; or
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            Attempt to obtain, or assist third parties in obtaining, unauthorised
            access to the Clips.
          </p>
        </li>
      </ul>
    </div>

    {/* 4.2 */}
    <div>
      <p>
        <strong>4.2</strong> Neither Party shall during or for one year after
        the Term approach the other Party or their Personnel directly with a
        view to completing any transaction outside of the VuPop services or
        platform. All Clips that have been sourced through VuPop must be
        licensed in accordance with these Clip Terms.
      </p>
    </div>
  </div>
</div>
{/* Clause 5 – Data Protection */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">5. DATA PROTECTION</h3>

  <div className="space-y-4 text-gray-300">
    <div>
      <p>
        <strong>5.1</strong> For the purposes of this Agreement, the words and
        phrases <strong>“data subjects”</strong> and{" "}
        <strong>“personal data”</strong> shall have the meanings given in the
        Data Protection Laws.
      </p>
    </div>

    <div>
      <p>
        <strong>5.2</strong> The Parties shall comply with the Data Protection
        Laws in relation to this Agreement. In particular, the Licensee warrants
        that it will only include personal data to VuPop where it has all
        necessary rights to do so, and where it has given all necessary notices
        to any relevant data subjects. This Clause 5.2 is in addition to, and
        does not relieve, remove or replace, either Party’s obligations or
        rights under the Data Protection Laws.
      </p>
    </div>
  </div>
</div>
{/* Clause 6 – Audit */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">6. AUDIT</h3>

  <div className="text-gray-300 space-y-4">
    <p>
      The Licensee undertakes that it shall maintain written, up-to-date records
      of its use of the Clip (including any sub-licences granted in relation to
      the Clip) and provide such records to the Licensor and/or VuPop within
      five (5) Business Days of such party’s written request from time to time
      during the Term or within three (3) years thereafter.
    </p>
  </div>
</div>
{/* Clause 7 – Intellectual Property Rights */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">
    7. INTELLECTUAL PROPERTY RIGHTS
  </h3>

  <div className="space-y-4 text-gray-300">
    <p>
      <strong>7.1</strong> The Licensee acknowledges and agrees that the Licensor
      (and/or its licensors) own all Intellectual Property rights in the Clip,
      and except as expressly stated in this Agreement, the Licensee does not
      acquire any rights to, under or in the Clips or any Intellectual Property
      rights therein.
    </p>

    <p>
      <strong>7.2</strong> The Licensor acknowledges and agrees that the Licensee
      will own all new Intellectual Property rights created by or on behalf of
      the Licensee that use, incorporate, or are otherwise derived from the
      Clip.
    </p>

    <p>
      <strong>7.3</strong> Neither Party shall use any trade mark, copyright,
      branding elements, or other Intellectual Property rights of the other
      Party without the other Party’s prior written consent, save to the extent
      that such trade mark, copyright, branding elements or other Intellectual
      Property rights form an inherent part of the Clip so that such use is
      permitted pursuant to Clause 2.1, or under applicable law.
    </p>

    <p>
      <strong>7.4</strong> The Licensor hereby waives absolutely, or warrants
      that it has procured the absolute waiver of, all moral rights arising under
      the Copyright, Designs and Patents Act 1988 in relation to the Clip and, so
      far as is legally possible, any broadly equivalent rights the Licensor may
      have in any territory of the world.
    </p>

    <p>
      <strong>7.5</strong> All rights not expressly granted by this Agreement are
      reserved.
    </p>
  </div>
</div>
{/* Clause 8 – Confidentiality */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">8. CONFIDENTIALITY</h3>

  <div className="space-y-4 text-gray-300">
    <p>
      <strong>8.1</strong> Each Party undertakes that it shall not at any time
      during the Term, and for a period of five years afterwards, disclose to
      any person any confidential information concerning the business, assets,
      affairs, customers, clients or suppliers of the other Party, nor any of
      the terms of this Agreement, except as permitted by Clause 8.2.
    </p>

    <p>
      <strong>8.2</strong> Each Party may disclose the other Party's confidential
      information:
    </p>

    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        <p>
          to its Personnel who need to know such information for the purposes of
          exercising the Party's rights or carrying out its obligations under or
          in connection with this Agreement. Each Party shall procure that its
          Personnel to whom it discloses the other Party's confidential
          information comply with the obligations set out in this Clause 8 as if
          they were a party to this Agreement; and
        </p>
      </li>
      <li>
        <p>
          as may be required by law, a court of competent jurisdiction or any
          governmental or regulatory authority.
        </p>
      </li>
    </ul>

    <p>
      <strong>8.3</strong> Neither Party shall use any other Party's confidential
      information for any purpose other than to exercise its rights or perform
      its obligations under or in connection with this Agreement.
    </p>

    <p>
      <strong>8.4</strong> Each Party agrees that VuPop may, where it considers
      it reasonably necessary, disclose such Party’s identity and contact
      details to the other Party.
    </p>
  </div>
</div>
{/* Clause 9 – Warranties and Indemnities */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">
    9. WARRANTIES AND INDEMNITIES
  </h3>

  <div className="space-y-4 text-gray-300">
    <p>
      <strong>9.1</strong> Each Party warrants and undertakes to the other that:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        it has and will maintain during the Term full power, capacity and
        authority to enter into this Agreement and to perform its obligations
        under this Agreement; and
      </li>
      <li>
        it shall comply with all applicable laws and regulations with respect to
        its activities under this Agreement.
      </li>
    </ul>

    <p>
      <strong>9.2</strong> The Licensor warrants and undertakes that:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        The Clip does not include any content or material that:
        <ul className="list-[lower-roman] ml-8 mt-2 space-y-2">
          <li>is unlawful, harmful, threatening, defamatory, obscene, infringing, harassing or racially or ethnically offensive;</li>
          <li>facilitates illegal activity;</li>
          <li>depicts sexually explicit images;</li>
          <li>promotes unlawful violence;</li>
          <li>is discriminatory based on race, gender, colour, religious belief, sexual orientation, or disability; or</li>
          <li>is otherwise illegal or causes damage or injury to any person or property;</li>
        </ul>
      </li>
      <li>The Clip does not contain any Virus or Vulnerability; and</li>
      <li>
        The Licensee’s receipt of the Clip does not, and shall not, infringe the
        rights, including any Intellectual Property rights, of any third party.
      </li>
    </ul>

    <p>
      <strong>9.3</strong> The Licensee warrants and undertakes that:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        Its use of the Clip shall be for legitimate business purposes and in
        compliance with all applicable laws and regulations;
      </li>
      <li>
        Without prejudice to the generality of Clauses 9.2(c) and 9.3(a), it has
        and will maintain during the Term all licences, consents, and
        permissions necessary for whatever use it chooses to make of the Clip;
        and
      </li>
      <li>
        It will bear sole liability for its use of the Clip, and for any
        consequences of such use.
      </li>
    </ul>

    <p>
      <strong>9.4</strong> Each Party undertakes that it will immediately raise
      an ‘issue’ in respect of the Clip through the VuPop Vault and/or give
      notice to VuPop pursuant to Clause 13.7 (quoting the Clip ID) if it has
      reason to believe or suspect, or any third party claims, that the Clip
      does not comply with Clauses 9.2 or 9.3.
    </p>

    <p>
      <strong>9.5</strong> Each Party acknowledges and agrees that:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        VuPop is not a party to this Agreement and VuPop shall have no liability:
        <ul className="list-[lower-roman] ml-8 mt-2 space-y-2">
          <li>under this Agreement to either Party; nor</li>
          <li>for ensuring or procuring either Party’s compliance with this Agreement; nor</li>
          <li>for any contents of the Clip; nor</li>
          <li>for the Licensee’s use of the Clip;</li>
        </ul>
      </li>
      <li>It shall not bring any claim against VuPop under this Agreement; and</li>
      <li>
        Any disputes between the Parties under this Agreement must be resolved
        by the Parties directly in accordance with Clause 12.
      </li>
    </ul>

    <p>
      <strong>9.6</strong> Each Party will hold VuPop harmless from, and
      indemnify VuPop on demand and keep VuPop fully and effectively indemnified
      from and against, all costs, expenses, damages and losses, including any
      interest, fines, legal and other professional fees and expenses awarded
      against or incurred or paid by VuPop, and any sums agreed to in
      settlement, as a result of, or in connection with, such Party’s actual or
      alleged breach of Clause 9.5.
    </p>

    <p>
      <strong>9.7</strong> All warranties, representations, conditions and all
      other terms of any kind whatsoever implied by statute or common law are,
      to the fullest extent permitted by applicable law, excluded from this
      Agreement.
    </p>
  </div>
</div>

{/* Clause 10 – Limitation of Liability */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">
    10. LIMITATION OF LIABILITY
  </h3>

  <div className="space-y-4 text-gray-300">
    <p>
      <strong>10.1</strong> Subject to Clauses 10.2 and 10.3, each Party’s total
      aggregate liability to the other in contract, tort (including negligence
      or breach of statutory duty), misrepresentation, restitution or otherwise,
      arising in connection with the performance or contemplated performance of
      this Agreement shall be limited to any portion of the Licence Fee that was
      (or could be) actually received by the Licensor under the App Terms.
    </p>

    <p>
      <strong>10.2</strong> Nothing in this Agreement excludes the liability of
      either Party:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>for death or personal injury caused by its negligence;</li>
      <li>for fraud or fraudulent misrepresentation;</li>
      <li>for any other liability which cannot be excluded or restricted under applicable law; or</li>
      <li>to VuPop pursuant to Clause 9.6.</li>
    </ul>

    <p>
      <strong>10.3</strong> Subject to Clause 10.2, neither Party shall be liable
      whether in tort (including for negligence or breach of statutory duty),
      contract, misrepresentation, restitution or otherwise for any:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>loss of profits, loss of business, wasted expenditure, depletion of goodwill and/or similar losses;</li>
      <li>loss or corruption of data or information;</li>
      <li>pure economic loss; or</li>
      <li>
        any special, indirect or consequential loss, costs, damages, charges or
        expenses, howsoever arising under this Agreement.
      </li>
    </ul>
  </div>
</div>
{/* Clause 11 – Term and Termination */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">11. TERM AND TERMINATION</h3>

  <div className="space-y-4 text-gray-300">
    <p>
      <strong>11.1</strong> This Agreement shall commence on the Effective Date
      and shall continue for the Term.
    </p>

    <p>
      <strong>11.2</strong> On termination or expiry of this Agreement for any
      reason:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        all licences granted to the Licensee under this Agreement shall
        immediately terminate;
      </li>
      <li>
        the Licensee shall, and shall procure that any Permitted Sub-Licensees
        shall:
        <ul className="list-[lower-roman] ml-8 mt-2 space-y-2">
          <li>immediately cease all use of the Clip; and</li>
          <li>
            delete (so far as technically feasible) all copies of the Clip and
            all Adaptations within its or their control; and
          </li>
        </ul>
      </li>
      <li>
        any rights, remedies, obligations or liabilities of the Parties that
        have accrued up to the date of termination, including the right to claim
        damages in respect of any breach of the Agreement which existed at or
        before the date of termination, shall not be affected or prejudiced.
      </li>
    </ul>

    <p>
      <strong>11.3</strong> Any provision of this Agreement which expressly, or
      by implication, is intended to come into or continue in effect on or after
      termination or expiry (including, without limitation, Clauses 1, 3, 4, 6,
      7, 8, 9.5, 9.6, 10, 11.2, 11.3, 12 and 13) shall remain in full force and
      effect.
    </p>
  </div>
</div>

{/* Clause 12 – Disputes */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">12. DISPUTES</h3>

  <div className="space-y-4 text-gray-300">
    <p>
      <strong>12.1</strong> If a dispute arises out of, or in connection with,
      this Agreement or the performance, validity or enforceability of it (a
      “Dispute”) then except as expressly provided in this Agreement, the
      Parties must follow the procedure set out in this clause before commencing
      court proceedings:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        Either party shall give to the other written notice of the Dispute by
        raising a ‘dispute’ in relation to the relevant Clip in the VuPop Vault,
        setting out the nature and full particulars of the dispute (a “Dispute
        Notice”), together with relevant supporting documents. On service of the
        Dispute Notice, a representative of each Party shall attempt in good
        faith to resolve the Dispute; and
      </li>
      <li>
        If the Parties are for any reason unable to resolve the Dispute within
        fourteen (14) days of service of the Dispute Notice, the Dispute shall
        be referred to a senior management representative of each Party, and the
        Parties shall attempt in good faith to resolve the Dispute for a further
        fourteen (14) days.
      </li>
    </ul>

    <p>
      <strong>12.2</strong> The Parties agree that:
    </p>
    <ul className="list-[lower-alpha] ml-8 mt-2 space-y-2">
      <li>
        Nothing in this Agreement shall waive, preclude, or otherwise limit
        their rights to apply to the Courts of England and Wales to:
        <ul className="list-[lower-roman] ml-8 mt-2 space-y-2">
          <li>pursue enforcement of an arbitrator’s award; or</li>
          <li>seek injunctive or other interim relief; and</li>
        </ul>
      </li>
      <li>
        VuPop shall have the right to receive and review copies of all
        correspondence and documentation exchanged by the Parties pursuant to
        Clause 12.1, and to attend any calls or meetings between the Parties in
        relation to any Dispute.
      </li>
    </ul>
  </div>
</div>

{/* Clause 13 – General */}
<div className="border border-gray-700 rounded-b-lg p-6 mt-6">
  <h3 className="text-xl font-bold text-white mb-4">13. GENERAL</h3>

  <div className="space-y-4 text-gray-300">
    <p>
      <strong>13.1</strong> Neither Party shall assign, transfer, mortgage,
      charge, subcontract, declare a trust over or deal in any other manner with
      any of its rights and obligations under the Agreement without the prior
      written consent of both the other Party and VuPop.
    </p>

    <p>
      <strong>13.2</strong> The Licensor and Licensee are independent contractors
      and shall not be deemed to be partners of, or otherwise associated with,
      each other in any way.
    </p>

    <p>
      <strong>13.3</strong> This Agreement shall be governed by the laws of
      England and Wales and shall be subject to the non-exclusive jurisdiction
      of the Courts of England and Wales.
    </p>

    <p>
      <strong>13.4</strong> This Agreement constitutes the entire agreement
      between the Parties relating to the matters provided for herein and
      supersedes all previous agreements, understandings or arrangements between
      the Parties relating to these matters and each of the Parties acknowledges
      and agrees that in entering into this Agreement it does not rely on, and
      will have no remedy in respect of, any statement, representation, warranty
      or understanding (whether negligently or innocently made) of any person
      (whether Party to the Agreement or not) other than as expressly set out in
      the Agreement. Nothing in this Clause shall limit or exclude any liability
      for fraud.
    </p>

    <p>
      <strong>13.5</strong> A waiver of any right or remedy is only effective if
      given in writing. A delay or failure to exercise, or the single or partial
      exercise of, any right or remedy shall not waive that or any other right
      or remedy, nor shall it prevent or restrict the further exercise of that
      or any other right or remedy.
    </p>

    <p>
      <strong>13.6</strong> Except as expressly provided in this Agreement, the
      rights and remedies provided under this Agreement are in addition to, and
      not exclusive of, any rights or remedies provided by law.
    </p>

    <p>
      <strong>13.7</strong> Any notices to be given under this Agreement shall,
      unless otherwise expressly stated, be in writing and shall be given by
      sending the same by email to{" "}
      <a
        onClick={(e) => {
                            e.preventDefault();
                            window.open(
                              "https://mail.google.com/mail/?view=cm&fs=1&to=contact@vupop.io",
                              "_blank"
                            );
                          }}
        className="underline text-yellow-400 hover:text-yellow-300"
      >
        contact@vupop.io
      </a>
      .
    </p>

    <p>
      <strong>13.8</strong> Any notice by email shall be deemed to have been
      delivered on the same day (if sent during Normal Working Hours), and if
      sent outside of Normal Working Hours, at 9am on the next Business Day.
      Clauses 13.7 and 13.8 do not apply to the service of any proceedings or
      other documents in any legal action or, where applicable, any other method
      of dispute resolution.
    </p>

    <p>
      <strong>13.9</strong> VuPop may enforce Clauses 2.3, 8.4, 9.4 to 9.6
      (inclusive), 12.2(b) and 13.1 of this Agreement.
    </p>

    <p>
      <strong>13.10</strong> Subject to Clause 13.9, no person who is not a
      party to this Agreement shall have any rights under the Contracts (Rights
      of Third Parties) Act 1999 to enforce any of its terms.
    </p>

    <p>
      <strong>13.11</strong> The Parties agree that VuPop’s transaction records
      will evidence each transaction under this Agreement (including each
      applicable Clip ID).
    </p>

    <p>
      <strong>13.12</strong> This Agreement may be executed in any number of
      counterparts, each of which when executed shall constitute a duplicate
      original, but all the counterparts shall together constitute the one
      agreement.
    </p>

    <p>
      <strong>13.13</strong> The invalidity or unenforceability of any
      provision, part-provision or any right arising under this Agreement shall
      not affect the validity or enforceability of any other provisions or
      rights. If any provision or part-provision is adjudged to be invalid or
      unenforceable, the relevant provisions shall apply with such deletions or
      modifications as may be necessary to make them valid and effective.
    </p>

    <p>
      <strong>13.14</strong> If any provision or part-provision of this
      Agreement is deemed deleted under Clause 13.12, the Parties shall
      negotiate in good faith to agree a replacement provision that, to the
      greatest extent possible, achieves the intended commercial result of the
      original provision.
    </p>
  </div>
</div>


           <div className="mt-8 pt-6 border-t border-gray-700 text-center text-yellow-400">
            <p>Last updated: 9 October 2025</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseeTerms;
